import { ChangeEvent, useCallback } from 'react';
import { useIntl } from 'react-intl';

import messages from '@/components/emotion-detector/messages';

import { MIN_SEEK_VALUE } from '../constants';
import { ProgressBar, SeekBarWrapper } from '../styles';

interface SeekBarProps {
	currentTime: number;
	duration: number;
	onSeek: (time: number) => void;
}

export default function SeekBar({ currentTime, duration, onSeek }: SeekBarProps) {
	const { formatMessage } = useIntl();

	const handleChange = useCallback(
		(e: ChangeEvent<HTMLInputElement>) => {
			const newTime = Number(e.target.value);
			onSeek(newTime);
		},
		[onSeek],
	);

	return (
		<SeekBarWrapper>
			<ProgressBar
				type="range"
				min={MIN_SEEK_VALUE}
				max={duration || MIN_SEEK_VALUE}
				value={currentTime || MIN_SEEK_VALUE}
				onChange={handleChange}
				aria-label={formatMessage(messages.audioPlayerSeek)}
			/>
		</SeekBarWrapper>
	);
}
